const types = {
  GET_QUICK_PERMIT_LOT: "GET_QUICK_PERMIT_LOT",
};

export default types;
